<form [formGroup]="projectForm" (ngSubmit)="onSubmit()" class="modern-form">
  <div class="form-section">
    <h3 class="section-title">Informations Générales</h3>
    @if (isLocked()) {
    <div class="alert alert-warning mb-4">
      Le projet est verrouillé (VALIDE/TERMINE). Seule l'assignation de workflow est autorisée.
    </div>
    }
    <div class="form-row">
      <div class="form-group col">
        <label for="name">NOM DU PROJET *</label>
        <input type="text" id="name" formControlName="name" class="form-control">
      </div>
      <div class="form-group col">
        <label>STATUT ACTUEL</label>
        <div class="status-inline">
          <span class="status-indicator" [style.background-color]="project.statusColor || '#64748b'"></span>
          <span class="status-name">{{ project.statusName || '-' }}</span>
          @if (project.metaStatus) {
          <span class="status-meta">{{ project.metaStatus }}</span>
          }
        </div>
        @if (isLocked()) {
        <p class="help-text">Le projet est verrouillé. Seule l'assignation de workflow reste modifiable.</p>
        }
      </div>
    </div>
    <div class="form-group mb-4">
      <label>WORKFLOW</label>
      @if (project.workflowName) {
      <div class="workflow-info">
        <span class="workflow-name-badge">{{ project.workflowName }}</span>
        <span class="step-info"> - Étape {{ project.currentStepOrder || 1 }}</span>
      </div>
      } @else {
      <p class="help-text">Aucun workflow assigné.</p>
      }
    </div>


    @if (currentWorkflow(); as workflow) {
    <div class="workflow-ux">
      <div class="workflow-title-row">
        <h4 class="workflow-title">Vue détaillée du workflow</h4>
        @if (isWorkflowCompleted()) {
        <span class="workflow-completed-badge">Workflow terminé</span>
        }
      </div>
      <div class="workflow-steps">
        @for (step of workflow.steps; track step.id || step.stepOrder) {
        <div class="workflow-step-card"
          [class.current-step]="project.currentStepOrder === step.stepOrder && !isWorkflowCompleted()"
          [class.completed]="isStepCompleted(step)">
          <div class="step-top">
            <div>
              <div class="step-name">
                Étape {{ step.stepOrder }} - {{ step.name }}
                @if (isStepCompleted(step)) {
                <span class="completed-check">✓</span>
                }
              </div>
              <div class="step-status-line">
                <span>{{ step.initialStatusName || 'Statut initial' }}</span>
                <span class="arrow">→</span>
                <span>{{ step.finalStatusName || 'Statut final' }}</span>
              </div>
            </div>
            @if (project.currentStepOrder === step.stepOrder && !isWorkflowCompleted()) {
            <span class="current-badge">Étape courante</span>
            }
          </div>

          <div class="step-assignments">
            @for (assignment of step.teamAssignments; track assignment.id || assignment.teamId) {
            <div class="assignment-pill">
              <span class="team-name">{{ assignment.teamName || ('Equipe #' + assignment.teamId) }}</span>
              <span class="team-actions">{{ getWorkflowActionsLabel(assignment.permissions) }}</span>
            </div>
            } @empty {
            <span class="assignment-empty">Aucune équipe associée</span>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    @if (workflowPermissions() && !workflowPermissions()?.noWorkflow && !isReadOnly) {
    @if ((workflowPermissions()?.canValidate || workflowPermissions()?.canReject) && !isWorkflowCompleted()) {
    <div class="workflow-actions">
      <button type="button" class="btn btn-outline btn-sm" [disabled]="!workflowPermissions()?.canValidate"
        (click)="requestValidateWorkflow()">
        Valider l'étape
      </button>
      <button type="button" class="btn btn-outline btn-sm" [disabled]="!workflowPermissions()?.canReject"
        (click)="requestRejectWorkflow()">
        Rejeter l'étape
      </button>
    </div>
    } @else if (!isLocked() && !isWorkflowCompleted()) {
    <div class="alert alert-warning mb-4">
      Vous ne faites pas partie de l'équipe projet et ne pouvez pas valider le workflow.
    </div>
    }
    }

    <div class="form-group">
      <label for="deliveryAddress">ADRESSE DE LIVRAISON</label>
      <input type="text" id="deliveryAddress" formControlName="deliveryAddress" class="form-control">
    </div>

    <div class="form-row">
      <div class="form-group col">
        <label for="city">VILLE</label>
        <input type="text" id="city" formControlName="city" class="form-control">
      </div>
      <div class="form-group col">
        <label for="zipCode">CODE POSTAL</label>
        <input type="text" id="zipCode" formControlName="zipCode" class="form-control">
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col">
        <label for="availabilityDate">DATE DE MISE À DISPOSITION *</label>
        <input type="date" id="availabilityDate" formControlName="availabilityDate" class="form-control">
      </div>
      <div class="form-group col">
        <label for="deliveryDate">DATE DE LIVRAISON *</label>
        <input type="date" id="deliveryDate" formControlName="deliveryDate" class="form-control">
      </div>
    </div>

    @if (projectForm.errors?.['dateRangeInvalid'] && (projectForm.get('deliveryDate')?.touched ||
    projectForm.get('availabilityDate')?.touched)) {
    <div class="alert alert-error mb-4">
      La date de livraison doit être postérieure ou égale à la date de mise à disposition.
    </div>
    }
  </div>

  @if (successMessage()) {
  <div class="alert alert-success mb-4">{{ successMessage() }}</div>
  }
  @if (localErrorMessage()) {
  <div class="alert alert-error mb-4">
    {{ localErrorMessage() }}
    <button class="close-alert" (click)="localErrorMessage.set('')">×</button>
  </div>
  }

  @if (!isReadOnly) {
  <div class="form-actions">
    <button type="submit" class="btn btn-primary" [disabled]="projectForm.invalid || isSaving() || !projectForm.dirty">
      {{ isSaving() ? 'Enregistrement...' : 'Enregistrer les modifications' }}
    </button>
  </div>
  }
</form>

@if (isWorkflowConfirmDialogOpen()) {
<app-confirmation-dialog [dialogTitle]="getWorkflowConfirmTitle()" [message]="getWorkflowConfirmMessage()"
  [confirmLabel]="getWorkflowConfirmLabel()" [isDanger]="pendingWorkflowAction() !== 'validate'"
  (confirm)="confirmWorkflowAction()" (cancel)="closeWorkflowConfirmDialog()">
</app-confirmation-dialog>
}

@if (isErrorDialogOpen()) {
<app-confirmation-dialog [dialogTitle]="'Erreur'" [message]="localErrorMessage()" [confirmLabel]="'Fermer'"
  [cancelLabel]="''" [isDanger]="true" (confirm)="closeErrorDialog()" (cancel)="closeErrorDialog()">
</app-confirmation-dialog>
}